
import React, { useState } from "react";
import Pagination from "react-bootstrap/Pagination";

interface Props {
    currentPage: number;
    totalPages: number;
    onPageChange: (page: number) => void;
}

export const CommonPagination = ({ currentPage, totalPages, onPageChange }: Props) => {

    if (totalPages <= 1) return null;

    return (
        <Pagination>
            <Pagination.Prev
                disabled={currentPage === 1}
                onClick={() => onPageChange(Math.max(currentPage - 1, 1))}
            />
            {[...Array(totalPages)].map((_, idx) => {
                const pageNum = idx + 1;
                return (
                    <Pagination.Item
                        key={pageNum}
                        active={pageNum === currentPage}
                        onClick={() => onPageChange(pageNum)}
                    >
                        {pageNum}
                    </Pagination.Item>
                );
            })}
            <Pagination.Next
                disabled={currentPage === totalPages}
                onClick={() => onPageChange(Math.min(currentPage + 1, totalPages))}
            />
        </Pagination>
    );

};
